
import { GridDataService } from './grid-data.service';
import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { MessageHandlerService } from '../../utility/message-handler.service';
import { Subscription } from 'rxjs';
import { sortBy } from 'lodash';
import { MessengerService } from '../messenger.service';

@Injectable()
export class AuditChannelListService extends GridDataService implements OnDestroy
{
  public auditTypes: Array<{ text: string; key: string; value: number }> = [
    { text: 'Channel', key: 'AUDIT-CHANNEL-TYPE-CHANNEL', value: 0 },
    { text: 'Assigned Staff', key: 'AUDIT-CHANNEL-TYPE-USERS', value: 1 },
    { text: 'Assigned Staff Groups', key: 'AUDIT-CHANNEL-TYPE-GROUPS', value: 2 },
    { text: 'Restricted Data Reasons', key: 'RESTRICTED-DATA-REASONS', value: 3 },
    { text: 'Goals', key: 'AUDIT-CHANNEL-TYPE-GOALS', value: 4 }
  ];

  private messagingLanguageChangedSubscription: Subscription;

  constructor(http: HttpClient, translate: TranslateService, messageHandlerService: MessageHandlerService,
    messengerService: MessengerService)
  {
    super(http, '/audit/channel/search', translate, messageHandlerService);
    this.loadLocalizations(translate);
    this.messagingLanguageChangedSubscription = messengerService.receiveMessage().subscribe({
      next: (message) =>
      {
        if (message && message.type && message.type === 'languageChanged')
        {
          this.loadLocalizations(translate);
        }
      }
    });
  }

  public ngOnDestroy(): void
  {
    if (this.messagingLanguageChangedSubscription !== undefined) { this.messagingLanguageChangedSubscription.unsubscribe(); }
  }

  public getAuditTypeText(auditType: number): string
  {
    let text = auditType.toString();
    const revision = this.auditTypes.find(x => x.value === auditType);
    if (revision !== undefined)
    {
      text = revision.text;
    }
    return text;
  }

  /**
   * Load localizations
   */
  private loadLocalizations(translate: TranslateService): void
  {
    // Set the audit types from localization
    const auditTypesTranslationKeys = this.auditTypes.map(a => a.key);
    translate.get(auditTypesTranslationKeys).subscribe({
      next: (res: string) =>
      {
        for (let i = 0; i < this.auditTypes.length; i++)
        {
          this.auditTypes[i].text = res[this.auditTypes[i].key];
        }
        this.auditTypes = sortBy(this.auditTypes, ['text']);
      }
    });
  }
}
